<template>
	<b-navbar id="navbar" toggleable="md" type="dark" variant="text-light bg-dark pl-0" fixed="top">
		<a :class="`${!siderCollapsed ? 'col-md-2 text-center p-0 sidebar-logo' : 'col-md-1 text-center p-0 sidebar-logo'}`">
			<router-link to="/home" class="nav-link">
				<img :src="require(`@/assets/${getImgSrc()}`)" class="d-inline-block align-top logo" alt="logo - f360" :style="`width: ${ !siderCollapsed ? '90px' : '24px'}`">
			</router-link>
		</a>
		<template v-if="!hide">
			<div id="toogleMenuMobile" @click="toogleMenuMobile" class="d-sm-block d-block d-lg-none">
				<i class="fas fa-bars"></i>
			</div>
			<div>
				<b-navbar-brand href="#" @click="toggleSideBar" class="d-sm-none d-none d-lg-block">
					<i class="fa fa-bars" aria-hidden="true"></i>
				</b-navbar-brand>
			</div>
      <!-- UPLOAD LOGO -->
      <UploadLogo />
			<div class="ml-auto">
				<b-collapse is-nav id="nav_collapse" class="pl-4">
					<!-- itens alinhados a direita -->
					<b-navbar-nav class="ml-auto">

							<b-nav-item-dropdown right class="d-sm-none d-none d-lg-block">
								<!-- dropdown -->
								<template slot="button-content">
									<em>{{ loggedUser() }}<i class="fas fa-cog" style="margin-left: 10px;"></i></em>
								</template>
								<b-dropdown-item>
									<span v-b-modal.edit_password @click="limparSenha">Alterar Senha</span>
								</b-dropdown-item>

								<b-dropdown-item>
									<span v-b-modal.edit_profile @click="limparPerfil">Alterar Perfil</span>
								</b-dropdown-item>

								<b-dropdown-item @click="logout">Sair</b-dropdown-item>
							</b-nav-item-dropdown>
						</b-navbar-nav>
					</b-collapse>
					<b-modal size="lg" id="edit_profile" title="Editar Perfil" ref="ModalformAlterarPerfil">
						<el-form ref="formAlterarPerfil" :model="formUser" :rules="rules.perfil" size="small" class="form-login">
							<el-form-item label="Nome" prop="newUserName" required>
								<el-input v-model="formUser.newUserName"></el-input>
							</el-form-item>
							<el-form-item label="E-mail" prop="newUserEmail" required>
								<el-input v-model="formUser.newUserEmail"></el-input>
							</el-form-item>
							<el-alert
								title="Atenção: O nome e e-mail seram atualizado após relogar no sistema"
								type="info"
								close-text="Ok">
							</el-alert>
						</el-form>
						<template #modal-footer="{ hide }">
							<div class="float-right">
								<el-button size="small" @click="hide()">Fechar</el-button>
                    			<el-button size="small" type="primary" @click="changeUserData">Salvar</el-button> 
							</div>
						</template>
					</b-modal>
					<b-modal size="lg" id="edit_password" title="Alterar Senha" ref="ModalformAlterarSenha">
						<el-form ref="formAlterarSenha" :model="formPassword" :rules="rules.senha" size="small" class="form-login">
							<el-form-item label="Senha" prop="password" required>
								<el-input v-model="formPassword.password" type="password" show-password></el-input>
							</el-form-item>
							<el-form-item label="Confirmar Senha" prop="passwordConfirmation" required>
								<el-input v-model="formPassword.passwordConfirmation" show-password></el-input>
							</el-form-item>
						</el-form>
						<div class="forca-senha-content" v-show="formPassword.password.length">
							<span>Força de senha:</span>
							<ul>
								<li :class="{ checked: minuscula }">- Conter ao menos 1 letra minúscula</li>
								<li :class="{ checked: maiuscula }">- Conter ao menos 1 letra maiúscula</li>
								<li :class="{ checked: numero }">- Conter ao menos 1 número</li>
								<li :class="{ checked: especial }">- Conter ao menos 1 caracter especial: <i>"! @@ # $ % & * ."</i></li>
								<li :class="{ checked: tamanho }">- Conter entre 8 a 16 caracteres</li>
							</ul>
						</div>
						<template #modal-footer="{ hide }">
							<div class="float-right">
								<el-button size="small" @click="hide()">Fechar</el-button>
                    			<el-button size="small" type="primary" @click="changePassword">Salvar</el-button> 
							</div>
						</template>
					</b-modal>
				</div>
			</template>
	</b-navbar>
</template>

<script>
import router from '@/router.js'
import hideElements from '@/mixins/hideElements';
import UploadLogo from './widgets/UploadLogo.vue';

export default {
	name: 'navbar',
  components: {
    UploadLogo
  },
	data(){
		return {
			active: true,
			user: '',
			hasLogo: false,
			loading: false,
			loginToken: localStorage.getItem('loginToken'),
			oldEmailUser:'',
			formPassword: {
				password: '',
				passwordConfirmation:'',
				typeReset: "logged"
			},
			formUser: {
				newUserName:'',
				newUserEmail:'',
			},
			rules: {
				perfil: {
					newUserName: [{ required: true, message: 'Nome é um campo obrigatório!', trigger: 'blur' }],
					newUserEmail: [{ required: true, message: 'E-mail é um campo obrigatório!', trigger: 'blur' }]
				},
				senha: {
					password: [{ required: true, message: 'Senha é um campo obrigatório!', trigger: 'blur' }],
					passwordConfirmation: [{ required: true, message: 'Confirme sua senha!', trigger: 'blur' }]
				}
			}
		}
	},
	mixins:[hideElements],
	methods: {
		toggleSideBar(){
			this.siderCollapsed = !this.siderCollapsed;
		},
		getImgSrc(){ // Altera src da imagem
			return !this.siderCollapsed ? 'novo-logo-f360.png' : 'logo-simbolo.png'
		},
		toogleMenuMobile(){ // sidebar mobile
			if(document.querySelector('#sidebar')){
				document.querySelector('#sidebar').classList.toggle("active-mobile")
			}
		},
		async logout(){
			const user = localStorage.getItem("user"); 
			const parse = JSON.parse(user);
			const {email} = parse.user;

			this.trackingF360(this, 'Logout', 'Dimensões personalizadas');

			localStorage.removeItem('user')
			localStorage.removeItem('accessToken')
			localStorage.removeItem('loginToken')
			localStorage.removeItem('isOnline')

			await this.axios.post(this.$urls.DELETE_TOKEN,{email:email,loginToken:this.loginToken});

			router.push({ path: '/', name: 'public' })
		},
		changePassword(){
			const ctx = this;

			ctx.$refs['formAlterarSenha'].validate((valid) => {
        if (!valid) {
					ctx.$notify.error({
						title: 'Validação',
						message: `Por favor, preencha todos os campos`,
						position:'top-left'
					});
					return;
				}

				const regexPassword = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&.*]).{8,16}$/);

				const { password, passwordConfirmation} = this.formPassword;

				if(!password || !passwordConfirmation){
					this.$notify.error({
						title: 'Validação',
						message: `Por favor, preencha todos os campos`,
						position:'top-left'
					});
					return;
				}
				if(password !== passwordConfirmation){
					this.$notify.error({
						title: 'Validação',
						message: `As senhas digitadas não coincidem`,
						position:'top-left'
					});
					return;
				}

				if(!regexPassword.test(password)){
					this.$notify.error({
						title: 'Validação',
						message: `A senha deve atender aos requisitos listados`,
						position:'top-left'
					});
				}

				ctx.changePasswordRequest();
			});
		},
		async changePasswordRequest() {
			const payLoad = { password: this.formPassword.password, token: this.loginToken, typeReset:this.formPassword.typeReset};
				
			try {
				await  this.axios.post(this.$urls.FORGOT_PASSWORD, payLoad);
				this.$notify({
						title: 'Sucesso',
						message: `Senha alterada com sucesso!`,
						position:'top-left',
						type: 'success'
				});

				this.$refs['ModalformAlterarSenha'].hide()
			} catch (error) {
				this.$notify.error({
						title: 'Ocorreu um erro no processo',
						message: `Houve um erro ao alterar sua senha`,
						position:'top-left'
				});
			}
		},
		
		changeUserData(){
			const ctx = this;

			ctx.$refs['formAlterarPerfil'].validate((valid) => {
        if (!valid) {
					ctx.$notify.error({
						title: 'Validação',
						message: `Por favor, preencha todos os campos`,
						position:'top-left'
					});
					return;
				}

				ctx.changeUserDataRequest();
			});
		},
		async changeUserDataRequest() {
			const { newUserEmail, newUserName} = this.formUser;

			const user = localStorage.getItem("user"); 
			const parse = JSON.parse(user);
			const {email} = parse.user;
			const payLoad = {newUserEmail, newUserName, token: this.loginToken, email:email};
			
			try {
				await  this.axios.post(this.$urls.CHANGE_USER_DATA, payLoad);
				this.$notify({
					title: 'Sucesso',
						message: `Usuario alterado com sucesso!`,
						position:'top-left',
						type: 'success'
				});

				this.$refs['ModalformAlterarPerfil'].hide()

			} catch (error) {
				this.$notify.error({
					title: 'Ocorreu um erro no processo',
						message: `Houve um erro ao alterar sua senha`,
						position:'top-left'
				});
			}
		},
		loggedUser() {
			const getUser = JSON.parse(localStorage.getItem('user')) || '';
			if(!getUser) return;

			return getUser.user.nome +' - '+ getUser.customer.nome;
		},
		limparPerfil() {
			this.formUser = {
				newUserName:'',
				newUserEmail:'',
			};
		},
		limparSenha() {
			this.formPassword = {
				password: '',
				passwordConfirmation:'',
				typeReset: "logged"
			}
		}
	},
  mounted(){
		document.querySelectorAll('#sidebar .nav-link').forEach(function(item){
			item.addEventListener('click',function(){
				if(document.querySelector('#sidebar')){
					document.querySelector('#sidebar').classList.remove('active-mobile')
				}
			});
		});
		
		const getUser = JSON.parse(localStorage.getItem('user')) || '';
		if(!getUser) return;
		this.user = getUser.user.nome +' - '+ getUser.customer.nome;
	},

	computed: {
		siderCollapsed: {
			get() {
				return this.$store.state.siderCollapsed;
			},
			set(value) {
				this.$store.commit('updateSiderCollapse', value);
			}
		},
		minuscula() {
      return /[a-z]/.test(this.formPassword.password)
    },
    maiuscula() {
      return /[A-Z]/.test(this.formPassword.password)
    },
    numero() {
      return /\d/.test(this.formPassword.password)
    },
    especial() {
      return /[!@#$%&*]/.test(this.formPassword.password)
    },
    tamanho() {
      return this.formPassword.password && this.formPassword.password.length >= 8 && this.formPassword.password.length <= 16
    }
	}
}
</script>
<style lang="scss">
	.sidebar-logo{
		transition:0.3s;
	}
	#toogleMenuMobile {
		color: #fff;
		position: absolute;
		right: 20px;
		font-size: 1.4em;
		border: 1px solid #fff;
		padding: 0 9.8px;
		border-radius: 3px;
		cursor: pointer;
	}
	#sidebar{
		&.active-mobile{
			display:block !important;
		}
	}
	
	
	.form-login{
		padding: 0 10px;
		input, button{
			width: 100%;
		}
		label {
			color: #797979;
		}
		::placeholder {
			color: #c7c6c6;
			font-size: 0.8em;
		}
		.btn-submit{
			width: 100%;
			background: #608db7 !important;
			border-color: #608db7 !important;
			&:hover{
				background: #5583af !important;
			}
		}
		.el-form-item--small .el-form-item__content {
			    margin-bottom: 11px;
		}
		.el-form-item--small .el-form-item__label {
			line-height: 10px;
		}
	}
	.forca-senha-content{
		font-size: 12px;
		font-weight: bold;
		margin-left: 48px;
		span{
			font-size: 13px;  
		}
	}
	li.checked {
		color: #0fa41a;
		position:relative;
	}
	li.checked:after {
		content: '✓';
		position:absolute;
		margin-left: 10px;
	}
	@media (max-width: 992px) { 
		#navbar .sidebar-logo{
			border:0 !important;
		}
		#logo-franqueador-img, #logo-franqueador{
			display:none;
		}
	}
</style>
